import styled, { css } from 'styled-components';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';
import {
  CardFooter,
  CardPreview,
  ItemCardStyled
} from '../../ui/ItemCard/styled';
import { Breakpoints } from '../../../styled/constants';
import { Typography } from '../../ui/Typography';
import { HeaderLeftAction } from '../../ui/PageHeader/styled';
import {
  ResidenceCardPreview,
  ResidenceCardStyled
} from '../../Cards/ResidencesCard/styled';

export const modalStyles = css`
  padding-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 20)};

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
`;

export const modalBackdropStyles = css`
  background-color: transparent;
`;

export const modalHeaderStyles = css`
  @media (min-width: ${Breakpoints.tablet}px) {
    ${HeaderLeftAction} {
      right: 0;
      left: auto;
    }
  }
`;

const itemCardStyles = css`
  ${ItemCardStyled} {
    max-width: 100%;
    margin: 0;

    &:not(:last-of-type) {
      margin-bottom: 15px;
    }

    ${CardPreview} {
      max-height: 200px;
      height: 200px;
      padding-top: 30%;
    }
  }

  ${CardFooter} {
    button {
      height: 50px;
      margin-top: 10px;
    }
  }
`;

const residenceCardStyles = css`
  ${ResidenceCardStyled} {
    margin: 0;

    ${ResidenceCardPreview} {
      max-height: 194px;
      height: 194px;
      padding-top: 30%;
    }
  }
`;

export const ModalContent = styled.div`
  padding: 20px 15px;
  height: 100%;
  overflow-y: scroll;

  ${itemCardStyles};
  ${residenceCardStyles};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 20px 25px;
  }
`;

export const ItemsCount = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
